module.exports = __webpack_public_path__ + "img/jelly1_thumb.8571cbf4.jpg";